import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import { TESTIMONIALS } from '../data/courseData';
import styles from './Testimonials.module.css';

export default function Testimonials() {
  const [ref, inView] = useInView();

  return (
    <section className={styles.section} id="reviews">
      <div className={styles.container}>
        <SectionHeader
          label="Student Stories"
          title="Real students. Honest outcomes."
          subtitle="Not cherry-picked hype. Here's what past students say about what the course actually delivered."
          center
        />
        <div className={styles.grid} ref={ref}>
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className={`${styles.card} ${inView ? styles.visible : ''}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div
                className={styles.badge}
                style={{ background: `${t.badgeColor}18`, color: t.badgeColor }}
              >
                {t.badge}
              </div>
              <div className={styles.stars}>
                {'★'.repeat(t.rating)}{'☆'.repeat(5 - t.rating)}
              </div>
              <p className={styles.text}>{t.text}</p>
              <div className={styles.author}>
                <div className={styles.avatar}>{t.initial}</div>
                <div>
                  <div className={styles.name}>{t.name}</div>
                  <div className={styles.role}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust bar */}
        <div className={styles.trustBar}>
          <div className={styles.trustItem}>
            <span className={styles.trustStar}>★★★★★</span>
            <span>4.8 average from 500+ students</span>
          </div>
          <div className={styles.divider} />
          <div className={styles.trustItem}>
            <span>🏅</span>
            <span>All reviews from real enrolled students</span>
          </div>
          <div className={styles.divider} />
          <div className={styles.trustItem}>
            <span>📍</span>
            <span>Pune-based · India-wide online access</span>
          </div>
        </div>
      </div>
    </section>
  );
}
